import { ProductOrBrand } from "./alternativeTypes";

export const householdProducts: ProductOrBrand[] = [
  // Household
  {
    name: "Ariel",
    ownerCountry: "US",
    comments: "Laundry detergent",
    categories: ["household", "laundry"],
  },
  {
    name: "Bonux",
    ownerCountry: "US",
    availableIn: ["FR"],
    comments: "Procter & Gamble",
    categories: ["household", "laundry"],
    sourceLinks: ["https://data.inpi.fr"] // search for Bonux
  },
  {
    name: "Dash",
    ownerCountry: "US",
    availableIn: ["FR", "BE"],
    comments: "Procter & Gamble",
    categories: ["household", "laundry"],
    sourceLinks: ["https://data.inpi.fr"] // search for Dash
  },
  {
    name: "Lenor",
    ownerCountry: "US",
    availableIn: ["DE", "BE", "FR"],
    comments: "Laundry detergent",
    categories: ["household", "laundry"],
    sourceLinks: ["https://de.pg.com/marken-und-produkte/"]
  },
  {
    name: "Swiffer",
    ownerCountry: "US",
    comments: "Renholdsprodukter",
    categories: ["household", "cleaning"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Swiffer"]
  },
  {
    name: "Ajax",
    ownerCountry: "US", // Colgate-Palmolive
    availableIn: ["NO"], // TODO
    categories: ["household", "cleaning"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Ajax_(cleaning_product)"]
  },
  {
    name: "Mr. Clean",
    ownerCountry: "US",
    notAvailableIn: ["DE", "FR", "NL", "BG", "UK", "PL"],
    categories: ["household", "cleaning"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Mr._Clean"]
  },
  {
    name: "Flash", // Mr. Clean
    ownerCountry: "US",
    availableIn: ["UK"],
    categories: ["household", "cleaning"],
  },
  {
    name: "Meister Proper", // Mr. Clean
    ownerCountry: "US",
    availableIn: ["DE"],
    categories: ["household", "cleaning"],
  },
  {
    name: "Mr. Propre", // Mr. Clean
    ownerCountry: "US",
    availableIn: ["FR"],
    categories: ["household", "cleaning"],
  },
  {
    name: "Mr. Proper", // Mr. Clean
    ownerCountry: "US",
    availableIn: ["NL", "BG", "PL"],
    categories: ["household", "cleaning"],
  },
  {
    name: "Mr. Muscle", // Mr. Clean
    ownerCountry: "US",
    availableIn: ["NL"],
    categories: ["household", "cleaning"],
  },
  {
    name: "Cascade",
    ownerCountry: "US",
    availableIn: ["CA"],
    comments: "Dishwashing detergent brand owned by Procter & Gamble",
    categories: ["household", "dishes"],
  },  
  {
    name: "Fairy",
    ownerCountry: "US",
    availableIn: ["UK", "IE", "FR", "ES", "PT", "PL", "DE"],
    categories: ["household", "dishes"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Fairy_(brand)"]
  },
  {
    name: "Dreft", // Fairy
    ownerCountry: "US",
    availableIn: ["NL", "BG", "BE"],
    categories: ["household", "dishes"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Fairy_(brand)"]
  },
  {
    name: "Yes", // Fairy
    ownerCountry: "US",
    availableIn: ["SE", "NO"],
    categories: ["household", "dishes"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Fairy_(brand)"]
  },
  {
    name: "Jar", // Fairy
    ownerCountry: "US",
    availableIn: ["CZ", "HR", "SI"],
    categories: ["household", "dishes"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Fairy_(brand)"]
  },
  {
    name: "Tide",
    availableIn: ["CA"],
    ownerCountry: "US",
    categories: ["household", "laundry"],
  },
  
  {
    name: "Vizir", // Tide
    ownerCountry: "US",
    availableIn: ["PL"],
    categories: ["household", "dishes"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Tide_(brand)"]
  },
  {
    name: "Daz", // Tide
    ownerCountry: "US",
    availableIn: ["UK"],
    categories: ["household", "dishes"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Tide_(brand)"]
  },
  {
    name: "Glade",
    ownerCountry: "US",
    comments: "Air freshener",
    categories: ["household", "air-freshener"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Glade_(brand)"]
  },
  {
    name: "Febreze",
    ownerCountry: "US",
    categories: ["household", "air-freshener"],
  },
  {
    name: "Energizer",
    ownerCountry: "US",
    categories: ["household", "batteries"],
  },
  {
    name: "Duracell",
    ownerCountry: "US",
    categories: ["household", "batteries"],
  },
  
  {
    name: "OMO",
    ownerCountry: "UK",
    comments: "Unilever",
    availableIn: ["UK", "FR", "CH", "AU"],
    categories: ["household", "laundry"],
    sourceLinks: ["https://en.wikipedia.org/wiki/List_of_Unilever_brands"]
  },
  {
    name: "Skip",
    ownerCountry: "UK",
    comments: "Unilever",
    availableIn: ["FR"],
    categories: ["household", "laundry"],
    sourceLinks: ["https://data.inpi.fr"]
  },
  {
    name: "Le Chat",
    ownerCountry: "DE",
    comments: "Henkel",
    availableIn: ["FR", "BE"],
    categories: ["household", "laundry"],
    sourceLinks: ["https://data.inpi.fr"]
  },
  {
    name: "Robijn",
    ownerCountry: "UK",
    comments: "Laundry Detergent",
    availableIn: ["NL", "BE"],
    categories: ["household", "laundry"],
    sourceLinks: ["https://nl.wikipedia.org/wiki/Robijn_(wasmiddel)"]
  },
  {
    name: "Albert Heijn",
    ownerCountry: "NL",
    comments: "Supermarket chain with its own range of products",
    availableIn: ["NL", "BE"],
    categories: ["household", "cleaning"],
    sourceLinks: ["https://www.ah.nl/"]
  },  
  {
    name: "Sorbo",
    ownerCountry: "NL",
    comments: "Cleaning products brand of Dayes Group.",
    availableIn: ["NL", "DE", "BE"],
    categories: ["household", "cleaning"],
    sourceLinks: ["https://dayes.eu/en/about-dayes"]
  },  
  {
    name: "OMO",
    ownerCountry: "NO",
    comments: "Laundry Detergent brand owned by Orkla",
    availableIn: ["NO"],
    categories: ["household", "laundry"],
    sourceLinks: ["https://omo.no"]
  },
  {
    name: "Neutral",
    ownerCountry: "UK",
    comments: "Laundry Detergent brand owned by Unilever",
    availableIn: ["NO"],
    categories: ["household", "laundry"],
    sourceLinks: ["https://www.neutral.no/home.html"]
  },
  {
    name: "Soak Wash",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["household", "laundry"],
    sourceLinks: [
      "https://soakwash.ca"
    ]
  },
  {
    name: "Tru Earth",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["household", "laundry"],
    sourceLinks: [
      "https://ca.tru.earth"
    ]
  },
  {
    name: "Arctic Power",
    ownerCountry: "CA",
    availableIn: ["CA"],
    comments: "Laundry detergent brand owned by Lavo",
    categories: ["household", "laundry"],
    sourceLinks: [
    ]
  },
  {
    name: "A+",
    ownerCountry: "ES",
    availableIn: ["NO"], // TODO
    categories: ["household", "laundry"],
    sourceLinks: [
      "http://www.bluesuncb.com/",
      "https://www.dnb.com/business-directory/company-profiles.bluesun_consumer_brands_sl.189f40977fac89167928d257c7dbb011.html"]
  },
  {
    name: "Frosch",
    ownerCountry: "DE",
    comments: "Laundry Detergent",
    availableIn: ["DE", "BE", "NL"], // TODO
    categories: ["household", "laundry"],
  },
  {
    name: "Essential",
    ownerCountry: "FR",
    comments: "Carrefour brand",
    availableIn: ["FR", "BE", "PL"], // TODO
    categories: ["household", "laundry"],
    sourceLinks: ["https://www.carrefour.fr"]
  },
  {
    name: "Expert",
    ownerCountry: "FR",
    comments: "Carrefour brand",
    availableIn: ["FR", "BE", "PL"], // TODO
    categories: ["household", "laundry"],
    sourceLinks: ["https://www.carrefour.fr"]
  },
  {
    name: "Air Wick",
    ownerCountry: "UK",
    availableIn: ["DE", "NL", "BE", "PL", "FR", "CA"], // TODO
    categories: ["household", "air-freshener"],
    sourceLinks: ["https://de.wikipedia.org/wiki/Reckitt_(Unternehmen)"]
  },
  {
    name: "Jif",
    ownerCountry: "NO",
    comments: "Renholdsprodukter",
    availableIn: ["NO"],  // TODO
    categories: ["household", "cleaning"],
    sourceLinks: ["https://no.wikipedia.org/wiki/Orkla_(selskap)"]
  },
  {
    name: "Hertel",
    ownerCountry: "CA",
    availableIn: ["CA"],
    comments: "Cleaning products brand owned by Lavo",
    categories: ["household", "cleaning"],
    sourceLinks: [
    ]
  },
  {
    name: "Vileda",
    ownerCountry: "DE",
    comments: "Vileda is a brand of mechanical and power cleaning products",
    availableIn: ["CA", "DE", "PL", "SE", "NL", "UK", "ES"],
    categories: ["household", "cleaning"],
    sourceLinks: ["https://no.wikipedia.org/wiki/Orkla_(selskap)"]
  },
  {
    name: "HG",
    ownerCountry: "NL",
    comments: "HG International makes effective products for cleaning, maintenance and repair in and around the house.",
    availableIn: ["NL", "BE", "UK"],  // TODO
    categories: ["household", "cleaning"],
    sourceLinks: ["https://hg.eu/uk/about-hg"]
  },
  
  {
    name: "Flota",
    ownerCountry: "ES",
    comments: "Laundry Detergent",
    availableIn: ["ES"],  // TODO
    categories: ["household", "laundry"],
  },
  {
    name: "La Salud",
    ownerCountry: "ES",
    comments: "Laundry Detergent",
    availableIn: ["ES"],  // TODO
    categories: ["household", "laundry"],
  },
  {
    name: "Persil",
    ownerCountry: "DE", 
    comments: "Laundry Detergent",
    availableIn: ["ES", "DE", "FR", "BE"],  // TODO
    categories: ["household", "laundry"],
    sourceLinks: ["https://de.wikipedia.org/wiki/Henkel_(Unternehmen)"]
  },
  {
    name: "Biovie",
    ownerCountry: "FR", 
    comments: "Compagnie Léa Nature",
    availableIn: ["FR"],  
    categories: ["household", "laundry"],
    sourceLinks: ["https://fr.wikipedia.org/wiki/Léa_Nature"]
  },
  {
    name: "Mir",
    ownerCountry: "DE", // Henkel 
    availableIn: ["FR"],  // TODO
    categories: ["household", "laundry"],
    sourceLinks: ["https://www.mir-et-moi.com"]
  },
  
  {
    name: "Dr. Beckmann",
    ownerCountry: "DE",
    availableIn: ["DE", "FR", "BE"], // TODO
    comments: "",
    categories: ["household", "cleaning", "air-freshener"],
    sourceLinks: []
  },
  {
    name: "Somat",
    ownerCountry: "DE", // Henkel
    availableIn: ["DE"], // TODO
    comments: "Dishwasher tablets",
    categories: ["household", "dishes"],
    sourceLinks: ["https://de.wikipedia.org/wiki/Somat"]
  },
  {
    name: "finish",
    ownerCountry: "UK",
    //availableIn: ["CA", "UK", "DE", "PL", "SE", "NL", "ES", "FR", "NO", "DK"], // TODO
    comments: "Dishwashing product brand owned by Reckitt",
    categories: ["household", "dishes"],
    sourceLinks: ["https://de.wikipedia.org/wiki/Somat"]
  },
  {
    name: "VARTA",
    ownerCountry: "DE",
    comments: "Batteries",
    categories: ["household", "batteries"],
    sourceLinks: []
  },
];